import { render } from "./CrimeProfileWidget.vue?vue&type=template&id=5e03b04c&ts=true"
import script from "./CrimeProfileWidget.vue?vue&type=script&lang=ts"
export * from "./CrimeProfileWidget.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__